const routers = [
    {
        path: '/search_result',
        name: 'search_result',
        meta: {
            exp: '搜索结果',
            requireAuth: false
        },
        // redirect:'/search_result_task',
        component: () => import('@/views/search_result/index.vue'),
        // children:[
        //     {
        //         path: '/search_result_task',
        //         name: 'search_result_task',
        //         meta: {
        //             exp: '搜索结果-设计任务',
        //             requireAuth: false
        //         },
        //         component: () => import('@/views/search_result/task/index.vue'),
        //     },
        //     {
        //         path: '/search_result_works',
        //         name: 'search_result_works',
        //         meta: {
        //             exp: '搜索结果-作品',
        //             requireAuth: false
        //         },
        //         component: () => import('@/views/search_result/works/index.vue'),
        //     },
        //     {
        //         path: '/search_result_designer',
        //         name: 'search_result_designer',
        //         meta: {
        //             exp: '搜索结果-设计师',
        //             requireAuth: false
        //         },
        //         component: () => import('@/views/search_result/designer/index.vue'),
        //     },
        //     {
        //         path: '/search_result_course',
        //         name: 'search_result_course',
        //         meta: {
        //             exp: '搜索结果-课程',
        //             requireAuth: false
        //         },
        //         component: () => import('@/views/search_result/course/index.vue'),
        //     },
        // ]
    },
]
export default routers